import React, { useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "../../../../components2/YhBox";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IJournalDetail } from "../dataJournalTypes";
import { useDataJournalModel } from "../dataJournalModel"
import { DetailType } from "../../../../types/FmsEnums";
import { useNavModel } from "../../../../model/navModel";
import { globalPrompt } from "../../../../components2/YhMessage"

const JournalList = () => {
    const { dataSource, page, selectedRowKeys, selectedRow, loadData, setSelectedRowKeys, setSelectedRow, reviewCode } = useDataJournalModel()
    const { addNav } = useNavModel()
    useEffect(() => {
        loadData()
    }, [])
    const columns: ColumnsType<IJournalDetail> = [
        {
            title: '序号',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: '数据目录编码',
            dataIndex: 'catalog',
        },
        {
            title: '分支编码',
            dataIndex: 'branch',
        },
        {
            title: '操作类型',
            dataIndex: 'execTypeName',
        },
        {
            title: '执行状态',
            dataIndex: 'execStatusName',
        },
        {
            title: '审核人',
            dataIndex: 'reviewer',
        },
        {
            title: '审核时间',
            dataIndex: 'reviewTime',
        },
        {
            title: '来源',
            dataIndex: 'sourceApp',
        },
        {
            title: '发起日期',
            dataIndex: 'createTime',
        },
        {
            title: '备注',
            dataIndex: 'note',
        }
    ];
    const onDetail = (type: string) => {
        const id = selectedRowKeys[0] as string //这里做类型转换
        switch (type) {
            case DetailType.look:
                if (selectedRowKeys.length == 0) return globalPrompt("message", { type: "error", text: "选择您要查看的数据" })
                return addNav("1-3-3", { id, mode: type });
            default:
                return false
        }
    }
    const audit = () => {
        const reduceArr = selectedRow.map(item => item.code) as string[]
        globalPrompt("modal", {
            title: "请求日志审核",
            text: `审核编码为${reduceArr.toString()}`,
            cancelShow: true,
            onOk: () => {
                const retData = reviewCode(reduceArr)
                return new Promise((resolve, reject) => {
                    if (retData) {
                        globalPrompt("message", { type: "warning", text: "审核成功" })
                        resolve("1")
                    } else {
                        globalPrompt("message", { type: "warning", text: "审核失败" })
                        reject("审核")
                    }
                })
            },
            onCancel: () => { console.log('关闭') }
        })
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("look")}
        >查看审核</Button>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => audit()}
        >审核</Button> */}
    </>
    const rowSelection = {
        onChange(selectedRowKeys: React.Key[], selectedRows: IJournalDetail[]) {
            setSelectedRowKeys(selectedRowKeys)
            // setSelectedRow(selectedRows)
        },
        selectedRowKeys
    }
    const onRow = (record: IJournalDetail) => {
        return {
            onClick: () => {
                let findArr = selectedRow.find(item => item.key === record.key) as IJournalDetail;
                console.log(findArr, selectedRow)
                if (findArr) {
                    let filterArr = selectedRow.filter(item => item.key !== findArr.key);
                    let filterKeys = selectedRowKeys.filter(item => item !== findArr.key) as React.Key[];
                    setSelectedRowKeys(filterKeys)
                    setSelectedRow(filterArr)
                } else {
                    setSelectedRowKeys([record.key as string])
                    setSelectedRow([record])
                }
            },
        }
    }
    return (
        <YhBox action={action}>
            <Table
                columns={columns}
                dataSource={dataSource}
                rowSelection={{
                    type: "radio",
                    ...rowSelection
                }}
                onRow={onRow}
                pagination={{
                    ...page,
                    position: ["bottomCenter"],
                    showTotal: () => `共${page.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}
export default JournalList